import React from 'react';
import { IconProps } from '../../../../assets/icons/types';

const CloseIcon = ({ className, color }: IconProps) => {
  return (
    <svg
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.19922 1.19995L10.5322 10.533"
        stroke={color ?? 'current-color'}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M10.7988 1.19995L1.46583 10.533"
        stroke={color ?? 'current-color'}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CloseIcon;
